import React from 'react';

import { flagStyles } from '../settings';

const SvgSB = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4608px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSB;
